// extracted by mini-css-extract-plugin
module.exports = {"container":"container--paEMxrfm","inputWrapper":"inputWrapper--Ee_O4ftg","textarea":"textarea--yFp7YHsn","button":"button--toGYpUcO","stopButton":"stopButton--q5gCaS8W"};